import React, { useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { useSetRecoilState } from "recoil";
import { UserInfo } from "../Components/atoms/atoms";

const base = process.env.REACT_APP_SERVER_URL;

// What deletion does, shared by the account page and the public /delete-account page.
export const deletionFacts = [
  "Your name, phone number and saved addresses are erased, and you can no longer sign in. You are signed out on every device.",
  "Unpaid carts are deleted, repair-request photos are deleted, and contact details are removed from your quote and repair requests.",
  "Records of paid orders are kept, because invoices, warranties and refunds depend on them.",
  "You stop receiving cart reminders and review requests.",
];

/** Delete-account section for the signed-in account page. Calls DELETE /user/me. */
export default function DeleteAccount({ token }: { token: string }) {
  const setUser = useSetRecoilState<any>(UserInfo);
  const navigate = useNavigate();
  const [open, setOpen] = useState(false), [password, setPassword] = useState(""), [busy, setBusy] = useState(false), [error, setError] = useState("");
  async function remove(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      await axios.delete(`${base}/user/me`, { headers: { Authorization: `Bearer ${token}` }, data: { password } });
      try { sessionStorage.removeItem("technogenious-checkout-v1"); } catch { /* nothing saved */ }
      setUser(null);
      navigate("/", { replace: true, state: { accountDeleted: true } });
    } catch (err: any) {
      const status = err?.response?.status, message = err?.response?.data?.message;
      setError(status === 400 && typeof message === "string" && !/exception$/i.test(message) ? message
        : status === 401 ? "Your sign-in has expired. Sign in again to delete your account."
        : status === 429 ? "Too many attempts. Please wait 15 minutes and try again."
        : "Your account could not be deleted. Please try again, or email technogeniousja@gmail.com.");
    } finally { setBusy(false); }
  }
  return <section className="account-delete" aria-labelledby="delete-heading">
    <h2 id="delete-heading">Delete your account</h2>
    {!open ? <button type="button" className="account-delete-open" onClick={() => setOpen(true)}>Delete my account…</button> : <form onSubmit={remove}>
      <ul>{deletionFacts.map(f => <li key={f}>{f}</li>)}</ul>
      <p><strong>This cannot be undone.</strong> <Link to="/delete-account">More about account deletion</Link></p>
      <label>Enter your password to confirm<input type="password" autoComplete="current-password" required maxLength={72} value={password} onChange={e => setPassword(e.target.value)} /></label>
      {error && <p role="alert">{error}</p>}
      <button className="account-delete-confirm" disabled={busy || !password}>{busy ? "Deleting…" : "Permanently delete my account"}</button>{" "}
      <button type="button" onClick={() => { setOpen(false); setPassword(""); setError(""); }}>Keep my account</button>
    </form>}
  </section>;
}
